import {Talep} from './talep';

export class UrunGrup {

  id: number;
  isim: string;
  tahminiTeslimGun: number;
  parentId: number;
  parent: UrunGrup;
  private pChildrens: UrunGrup[];

  childrenCount: number;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.parent != null) {
      this.parent = new UrunGrup(obj.parent);
    }
  }

  public get childrens(): UrunGrup[] {
    return this.pChildrens;
  }

  public set childrens(list: UrunGrup[]) {
    if (list != null) {
      this.pChildrens = list.map(t => new UrunGrup(t));
    }
  }

}
